import React from 'react';

export const Stats = () => <div> stats here </div>;
